/**
 * Building blocks shared by the REST endpoint modules: the base URL (from
 * `CHAT_API_URL` / `VITE_CHAT_API_URL` per environment), the bearer header, and
 * `chatFetch` — the fetch every Costanza call must go through.
 */
import { runFetch, type ResponseType, type RunFetchOptions } from "fetcher"
import { CHAT_API_URL } from "../../env"

export const chatBaseUrl = (): string => {
  if (CHAT_API_URL) return CHAT_API_URL

  throw new Error("CHAT_API_URL is not configured (set VITE_CHAT_API_URL)")
}

export const bearer = (token: string) => ({ Authorization: `Bearer ${token}` })

/**
 * `runFetch` redirects the whole SPA to the login service on any 401
 * (`auth.refreshLogin`). That's right for the platform API, but Costanza is a
 * separate service: a 401 from it means the chat session/token is bad — or
 * Costanza itself is misconfigured — never that the user's Engage session died.
 * So every chat call goes through here with `skipLoginRedirect` forced on, and
 * the controller handles the failure locally (disconnect chat, leave the app
 * untouched). Use this, not `runFetch`, for new Costanza endpoints.
 */
export const chatFetch = <T, R extends ResponseType>(
  options: RunFetchOptions<T, R>
): Promise<T> => runFetch<T, R>({ ...options, skipLoginRedirect: true })
